import { useQuery } from '@tanstack/react-query';
import type { Permission, Role } from '@prism/contracts';
import { api } from '../client';
import { queryKeys } from '../queryKeys';

export interface Me {
  user: { id: string; email: string; displayName: string };
  workspace: { id: string; name: string };
  role: Role;
  roleLabel: string;
  permissions: Permission[];
  groups: string[];
  /** A password an administrator set: it must be changed before anything else. */
  mustChangePassword?: boolean;
  /** A browser session: the idle timeout in minutes (0 = off). Null when signed in with an API key. */
  session?: { idleMinutes: number; authMethod?: 'password' | 'sso' } | null;
  /** Two-step sign-in is required and not set up (1.0.0-rc.4): the app shows only its setup. */
  mfaEnrolmentRequired?: boolean;
  /** The account has a PRISM password (one made at a single sign-on has none). */
  hasPassword?: boolean;
}

export function useMe() {
  return useQuery({ queryKey: queryKeys.me(), queryFn: () => api<Me>('/api/v1/me'), retry: false, staleTime: 60_000 });
}
